module.exports = {"130284001":"滦河街道","130284002":"古城街道","130284003":"滦城路街道","130284004":"响嘡街道","130284102":"东安各庄镇","130284103":"雷庄镇","130284104":"茨榆坨镇","130284105":"榛子镇","130284106":"杨柳庄镇","130284107":"油榨镇","130284108":"古马镇","130284109":"小马庄镇","130284110":"九百户镇","130284111":"王店子镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130284.json
// module id = 184
// module chunks = 0